import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box } from '@mui/material';

const COLORS = [
  '#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#8dd1e1',
  '#d0ed57', '#a4de6c', '#d8854f', '#e38690', '#5ABBD4'
];


const ORDER_DEFINITIONS = {
  age_range: ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"],
  gender: ["Man", "Woman"],
  employment_status: ["Independent", "Part-time", "Full-time", "Unemployed"],
  income: [ "<10000", "10000-19999", "20000-29999", "30000-39999", "40000-49999", "50000-99999", "100000-199999", ">200000", ],
  education: [ "Elementary", "Low High school", "MBO/ High school", "HBO/WO Bachelor", "Master or PHD", ],
  household_situation: [ "Kids living at home", "Living alone", "Living together without kids unmarried", "Living together married without kids", "Living together with kids unmarried", "Living together married with kids", "Parent living alone", "Other", "Person in institutional housing", ],
  marital_status: ["Unmarried", "Married", "Widowed", "Divorced"],
};

function getSortedKeys(attribute, foundKeys) {
  const predefinedOrder = ORDER_DEFINITIONS[attribute];

  if (!predefinedOrder) {
    return [...foundKeys].sort();
  }

  return predefinedOrder.filter((k) => foundKeys.includes(k));
}

export { ORDER_DEFINITIONS, getSortedKeys };

const CustomAxisTick = ({ x, y, payload }) => {

  let parts = payload.value.split(/(-|\s+)/).filter(Boolean);
  const maxLength = 10; 
  let lines = [];
  let currentLine = '';

  parts.forEach(part => {
    const tentative = currentLine ? currentLine + ' ' + part : part;
    if (tentative.length <= maxLength && lines.length < 2) {
      currentLine = tentative;
    } else {
      if (currentLine) {
        lines.push(currentLine);
      }
      currentLine = part;
    }
  });

  if (currentLine) {
    lines.push(currentLine);
  }

  if (lines.length > 2) {
    let combined = lines.slice(1).join(' ');
    if (combined.length > maxLength) {
      combined = combined.slice(0, maxLength - 3) + '...';
    }
    lines = [lines[0], combined];
  }

  const yOffset = -(lines.length - 1) * 1.5 + 10;

  return (
    <g transform={`translate(${x},${y})`}>
      {lines.map((line, index) => (
        <text
          key={index}
          x={0}
          y={yOffset + index * 18}
          dy={12}
          textAnchor="middle"
          fill="#666"
        >
          {line}
        </text>
      ))}
    </g>
  );
};



const BarChartComponent = ({ questionText, groupedResponses, attribute, height = 470  }) => {
  
  const allKeys = new Set();

  groupedResponses.forEach((row) => {
    Object.keys(row).forEach((k) => {
      if (k !== 'option') allKeys.add(k);
    });
  });

  const uniqueKeys = [...allKeys];
  const sortedKeys = getSortedKeys(attribute, uniqueKeys);

  return (
    <Box sx={{ width: '100%', height: height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={groupedResponses} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
          <XAxis dataKey="option" interval={0} tick={<CustomAxisTick />}/>
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend wrapperStyle={{ paddingTop: 30 }}/>
          {sortedKeys.map((key, index) => (
            <Bar key={key} dataKey={key} stackId="a" fill={COLORS[index % COLORS.length]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default BarChartComponent;
